// extracted by mini-css-extract-plugin
export default {"wrapper":"Popup_wrapper__x4+7c","visible":"Popup_visible__ODTkN","btn":"Popup_btn__dodQM","cross":"Popup_cross__CPzuX"};